__turbopack_context__.v({
  "labelLong": "VR3SFa_labelLong",
  "labelShort": "VR3SFa_labelShort",
});
